'use client'

import Link from '@components/primitives/Link'
import properCase from '@lib/utilities/text/properCase'
import createFacetFiltersFromSlug from '@modules/trials/search/facetFilters/createFacetFiltersFromSlug'
import formatSearchResultsTitle from '@modules/trials/search/formatSearchResultsTitle'
import { usePathname } from 'next/navigation'

export default function ListingDetails({
  activeConditionLabel,
  activeLocationLabel,
  activeTreatmentLabel,
  trialCount,
}: {
  activeConditionLabel?: string
  activeLocationLabel?: string
  activeTreatmentLabel?: string
  trialCount: number
}) {
  const pathname = usePathname()
  const { paid } = createFacetFiltersFromSlug(pathname ?? '')

  const searchResultsCount = trialCount
  const titleText = formatSearchResultsTitle({
    activeLocationLabel,
    conditionOrIntervention: activeConditionLabel ?? activeTreatmentLabel,
    isPaid: Boolean(paid),
    searchResultsCount,
  })

  return (
    <div className='mx-5 lg:mx-0 lg:w-full'>
      <h1 className='pb-2 text-[length:1.125rem] font-semibold leading-[180%] text-black lg:text-[length:2rem] lg:font-bold lg:leading-[115%]'>
        {titleText}
      </h1>
      <div className='relative'>
        <h2 className='mb-2 text-sm leading-normal text-neutral700 antialiased'>
          Power is an online platform that helps thousands of{' '}
          {activeConditionLabel ? `${properCase(activeConditionLabel)} ` : ''}
          patients discover FDA-reviewed trials every day. Every trial we
          feature meets safety and ethical standards, giving patients an easy
          way to discover promising new treatments in the research stage.
        </h2>
        <Link
          className='text-sm font-semibold text-primary500 underline underline-offset-4 hover:text-primary600 lg:hidden'
          href='#learn-more-about-power'
        >
          Learn More About Power
        </Link>
      </div>
    </div>
  )
}
